const convertFirstLetterToLowercase = (string: string): string =>
  string.charAt(0).toLowerCase() + string.slice(1);

export default convertFirstLetterToLowercase;
